import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="section-padding bg-background-100">
      <div className="section-container">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 rounded-3xl bg-background-50 border border-background-200/70 p-8 md:p-12">
          {/* Left */}
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              {appData.title}
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              {appData.description}
            </p>
            <div className="mt-6 space-y-2">
              {appData.features.map((f, i) => (
                <div key={i} className="flex items-center gap-2 justify-center lg:justify-start">
                  <i className="ri-checkbox-circle-fill text-primary-500 text-lg"></i>
                  <span className="text-sm text-foreground-700">{f}</span>
                </div>
              ))}
            </div>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="px-6 py-2.5 bg-foreground-900 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2">
                <i className="ri-apple-fill text-lg"></i>
                App Store 下载
              </button>
              <button className="px-6 py-2.5 bg-foreground-900 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2">
                <i className="ri-google-play-fill text-lg"></i>
                Google Play 下载
              </button>
            </div>
          </div>

          {/* Right */}
          <div className="flex-shrink-0 w-48 h-48 md:w-56 md:h-56 rounded-3xl bg-primary-500/10 flex items-center justify-center overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20themed%20mobile%20app%20interface%20mockup%20showing%20news%20feed%20with%20ranking%20cards%2C%20warm%20red%20and%20amber%20color%20accents%2C%20modern%20UI%20design%2C%20clean%20layout%2C%20minimalist%20style&width=560&height=560&seq=app-preview&orientation=squarish"
              alt="每日黑料App界面预览"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}